import SkipLink from '@/components/SkipLink'
import {VIEW_HOME_EVENT} from '@/constants/events'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import {type SearchInputControl} from '@/layout/SearchInputWithAutocomplete'
import HeadTags from '@/lib/head/HeadTags'
import {HomeRoute} from '@/routeRegistry'
import skipTargetProps from '@/utils/a11y/skipTargetProps'
import useLogPageViewEvent from '@/utils/hooks/useLogPageViewEvent'

import BeMyEyesSection from './components/BeMyEyesSection/BeMyEyesSection'
import style from './Home.module.scss'

const HomePageDefaultContent = lazy(
  async () => import('./components/HomePageDefaultContent/HomePageDefaultContent'),
)

const HomePageSearchResult = lazy(
  async () => import('./components/HomePageSearchResult/HomePageSearchResult'),
)

const focusOnSearchInput = (node: SearchInputControl | null) => {
  if (node) {
    node.focus()
  }
}

export default memo(function Home() {
  useLogPageViewEvent(VIEW_HOME_EVENT)

  const {q, ref} = HomeRoute.useSearch()

  return (
    <div className={style.Container}>
      <div className={style.Page}>
        <HeadTags title='Shop' />
        <SkipLink title='Skip to main content' to='#main-content' />
        <Navbar variant='dark' withSearch displayNavBanner />
        <main {...skipTargetProps('main-content')}>
          {!q && (
            <Suspense fallback={null}>
              <HomePageDefaultContent searchInputRef={focusOnSearchInput} />
              {ref === 'bemyeyes' && (
                <div className={style.BeMyEyesWrapper}>
                  <BeMyEyesSection />
                </div>
              )}
            </Suspense>
          )}
          {q && (
            <Suspense fallback={null}>
              <HomePageSearchResult q={q} />
            </Suspense>
          )}
        </main>
      </div>
      <Footer />
    </div>
  )
})
